const init = function() {
	cloneResponseIntro();
};

/**
 *
 *
 *
 */
const cloneResponseIntro = function() {

	if ( document.body.classList.contains('single-response-parent') ) {

		const referenceNode = document.querySelector('.has-left-sidebar h1');
		const sourceNode = document.querySelector('.has-right-body p:first-child');
		const clonedNode = sourceNode.cloneNode(true);
		const container = document.createElement('div');

		container.classList.add('intro-swap-container');
		container.appendChild(clonedNode);
		referenceNode.after(container);

	}

};

const api = {
	init: init
};

export default api;